/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GetDocumentOpportunityUsersResponse1DataFromJSON, GetDocumentOpportunityUsersResponse1DataToJSON } from './GetDocumentOpportunityUsersResponse1Data';
export function GetDocumentOpportunityUsersResponse1FromJSON(json) {
    return GetDocumentOpportunityUsersResponse1FromJSONTyped(json, false);
}
export function GetDocumentOpportunityUsersResponse1FromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: !exists(json, 'status') ? undefined : json['status'],
        data: !exists(json, 'data') ? undefined : GetDocumentOpportunityUsersResponse1DataFromJSON(json['data'])
    };
}
export function GetDocumentOpportunityUsersResponse1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetDocumentOpportunityUsersResponse1DataToJSON(value.data)
    };
}
